// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"6b28ac05","151":"cc8124dd"}[chunkId] + ".chunk.js";
};